import React from 'react';
import {Edit, SimpleForm, TextInput,} from 'react-admin';
import {isRequired} from "../util/validation";
import {CustomEditToolbar} from "../util/customEditToolbar";


export const CompanyNewsTypeEdit = () => (
  <Edit undoable="false">
    <SimpleForm redirect="list" toolbar={<CustomEditToolbar/>}>
      <TextInput source="X10TCNTCODE"
                 name="X10TCNTCODE"
                 validate={isRequired}
                 label="Code"/>
      <TextInput source="X10TCNTDESCRIPTION"
                 name="X10TCNTDESCRIPTION"
                 validate={isRequired}
                 label="Description"/>
    </SimpleForm>
  </Edit>
);


